import { List } from 'immutable';
import * as ActionTypes from '../../actions/ActionTypes';
import ArticleVideosRecord from '../../records/insights/ArticleVideosRecord';
export function getVideos(videos = []) {
  // @ts-expect-error ts-migrate(7009) FIXME: 'new' expression, whose target lacks a construct s... Remove this comment to see the full error message
  return new List(videos);
}
const INITIAL_STATE = new ArticleVideosRecord();
export default function articleVideos(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ActionTypes.FETCH_ARTICLE_VIDEOS_PENDING:
      return state.merge({
        isRequesting: true,
        error: undefined
      });
    case ActionTypes.FETCH_ARTICLE_VIDEOS_SUCCESS:
      return state.merge({
        videos: getVideos(action.payload),
        error: undefined,
        isRequesting: false,
        // @ts-expect-error ts-migrate(2322) FIXME: Type 'number' is not assignable to type 'null | un... Remove this comment to see the full error message
        lastLoaded: new Date().valueOf()
      });
    case ActionTypes.FETCH_ARTICLE_VIDEOS_ERROR:
      return state.merge({
        isRequesting: false,
        error: action.error
      });
    default:
      return state;
  }
}